import React, { useContext } from 'react'
import { Modal, View } from 'oio-react'
import Helmet from 'react-helmet'
import { Switch, useParams, useRouteMatch } from 'react-router-dom'
import ContentView from 'src/components/Content/View'
import Footer from 'src/components/Footer'
import ModalRoute from 'src/components/utils/ModalRoute'
import { useOrganization, usePage } from 'src/graphql/hooks'
import PageActions from 'src/legacy/5.6/PageActions'
import PageUIContext from 'src/libraries/contexts/PageUI'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'
import PageStatusBar from '~/components/StatusBar'
import PageContext from '~/libraries/context'
import PageVisualEditor from '~/pages/VisualEditor'

const Page = () => {
   const { pageSlug } = useParams()
   const match = useRouteMatch()
   const { protoTheme: theme } = useContext(ProtoThemeContext)

   const pageQueryOptions = {
      withContent: true
   }

   // TODO: DEPRECATE WHEN WE COMBINE SLUGS AND URLS
   // The substring below is to remove the leading slash that comes from
   // the match url from useRouteMatch
   // See PR #285
   if (match.url.startsWith('/pages')) {
      pageQueryOptions.slug = pageSlug
   } else {
      pageQueryOptions.url = match.url.substring(1)
   }

   const { page, loading: pageIsLoading } = usePage(pageQueryOptions)
   const { organization } = useOrganization()
   const { currentUserCanEdit } = organization

   const isBleedingEdge = organization.gatherAppVersion === 6

   // GNS3 and Fuse are currently only communities that use pages with custom page components
   // See PR #701
   const isCustomPage = isBleedingEdge || ['fuse', 'gns3'].includes(organization.slug)

   if (pageIsLoading) {
      return null
   }

   return (
      <PageContext.Provider value={page}>
         <Helmet title={`${page.title} | ${organization.name}`} />
         <View
            float="left"
            width="100%">
            <PageStatusBar page={page} />
            <View
               float="left"
               width="100%"
               minHeight="90vh"
               backgroundColor={theme.tmpContentBackgroundColor}
               paddingVertical={!isCustomPage && '30px[a-b] 60px[c-f]'}>
               <PageUIContext.Provider
                  value={{
                     contentMaxWidth: isCustomPage ? '100%' : '800px',
                     contentPaddingLeft: !isCustomPage && theme.tmpViewportPadding,
                     contentPaddingRight: !isCustomPage && theme.tmpViewportPadding,
                     contentPaddingVertical: !isCustomPage && '12px'
                  }}>
                  <ContentView elements={page.body.elements} />
               </PageUIContext.Provider>
            </View>
         </View>
         {!isBleedingEdge && (
            <Footer
               {...isCustomPage && {
                  backgroundColor: '#000',
                  textColor: '#777'
               }}
            />
         )}
         {!isBleedingEdge && currentUserCanEdit && <PageActions page={page} />}
         {currentUserCanEdit && (
            <Switch>
               <ModalRoute path={`${match.path}/edit`}>
                  {({ open, onCloseComplete, onCloseTrigger }) => (
                     <Modal
                        borderRadius="6px"
                        width="100%"
                        height="100%"
                        onCloseComplete={onCloseComplete}
                        onCloseTrigger={onCloseTrigger}
                        openAnimationName="fadeIn"
                        open={open}>
                        <PageVisualEditor returnUrl={match.url} />
                     </Modal>
                  )}
               </ModalRoute>
            </Switch>
         )}
      </PageContext.Provider>
   )
}

export default Page
